/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownHealthCondition } from '../models/db_DropdownHealthCondition';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HealthConditions {
    /**
     * Get a list of health conditions
     * @returns db_DropdownHealthCondition OK
     * @throws ApiError
     */
    public static listHealthConditions(): CancelablePromise<Array<db_DropdownHealthCondition>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health-conditions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
